module.exports = __webpack_public_path__ + "img/order_user_flex.be5a684a.jpg";